import { render, staticRenderFns } from "./ContainerWorkflowEditor.vue?vue&type=template&id=0ba2a3cc"
import script from "./ContainerWorkflowEditor.vue?vue&type=script&lang=js"
export * from "./ContainerWorkflowEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports